import { DocumentData, DocumentReference, DocumentSnapshot, QuerySnapshot, collection, doc, getFirestore, onSnapshot, CollectionReference } from 'firebase/firestore'
import { eventChannel } from 'redux-saga'
import { cancelled, take } from 'typed-redux-saga'
import { firebaseApp } from '#/utils/firebase'

export function* watchForFirestore(
  ref: DocumentReference<DocumentData> | CollectionReference<DocumentData>,
  handler: (snapshot: any) => Generator<unknown>
) {
  const channel = eventChannel<{
    snapshot: unknown
  }>(emit =>
    // @ts-ignore
    onSnapshot(ref, snapshot => emit({ snapshot })))

  try {
    while (true) {
      const { snapshot } = yield* take(channel)
      yield* handler(snapshot)
    }
  } finally {
    if (yield* cancelled()) {
      channel.close()
    }
  }
}

export function* watchForDocument(
  path: string,
  handler: (
    snapshot: DocumentSnapshot<DocumentData>
  ) => Generator<unknown>
) {
  const db = getFirestore(firebaseApp)
  const ref = doc(db, path)
  yield* watchForFirestore(ref, handler)
}

export function* watchForCollection(
  path: string,
  handler: (snapshot: QuerySnapshot<DocumentData>) => Generator<unknown>
) {
  const db = getFirestore(firebaseApp)
  const ref = collection(db, path)
  yield* watchForFirestore(ref, handler)
}
